import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Badge,
  Box,
  Button,
  Flex,
  Icon,
  SimpleGrid,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { HeaderCard } from "../../../../components/headerCard";
import { CarDTO } from "../../../../dtos/CarDTO";
import { useEffect, useRef, useState } from "react";
import { useListCar } from "../hooks/useListCar";
import { useDeleteCar } from "../hooks/useDeleteCar";
import { RiCloseFill, RiPencilFill } from "react-icons/ri";
import { UpdateStatus } from "./components/updateStatus";

export function ListCar() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const [carInfo, setCarInfo] = useState<CarDTO>({} as CarDTO);

  const { getCar, isLoading, data } = useListCar();
  const { deleteCar, loadingDelete } = useDeleteCar();

  const cancelRef = useRef<any>(null);

  async function deleteCarData(id: string) {
    try {
      await deleteCar(id);

      toast({
        position: "top-right",
        title: "Motorista",
        description: "Frota removido com sucesso.",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        position: "top-right",
        title: "Motorista",
        description: "Não foi possível remover a frota.",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    } finally {
      onClose();
      setCarInfo({} as CarDTO);
      getCar();
    }
  }

  useEffect(() => {
    getCar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      <HeaderCard title="FROTA" titleButton="Nova frota" link="/frota/novo" />
      {isLoading && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          height={500}
        >
          <Spinner
            color="green.600"
            emptyColor="white"
            thickness="4px"
            size="xl"
            h={100}
            w={100}
          />
        </Box>
      )}

      <SimpleGrid
        flex="1"
        gap="4"
        minChildWidth="320px"
        alignItems="flex-start"
        px={1}
        py={1}
      >
        {data.length > 0 && !isLoading && (
          <Box p="4" borderRadius={8} height={500} overflow="scroll">
            <TableContainer>
              <Table variant="striped" colorScheme="gray" size="sm">
                <Thead>
                  <Tr bg="green.600" height="10">
                    <Th></Th>
                    <Th color="white" textAlign="center">
                      CÓDIGO
                    </Th>
                    <Th color="white" textAlign="center">
                      PLACA
                    </Th>
                    <Th color="white" textAlign="center">
                      GRUPO
                    </Th>
                    <Th color="white" textAlign="center">
                      TIPO FROTA
                    </Th>
                    <Th color="white" textAlign="center">
                      CÓD. ADESIVO
                    </Th>
                    <Th color="white" textAlign="center">
                      MODELO
                    </Th>
                    <Th color="white" textAlign="center">
                      ANO
                    </Th>
                    <Th color="white" textAlign="center">
                      PROPRIEDADE
                    </Th>
                    <Th color="white" textAlign="center">
                      STATUS
                    </Th>
                    <Th color="white" textAlign="center">
                      AÇÕES
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {data.map((item, index) => (
                    <Tr key={index}>
                      <td>
                        <UpdateStatus
                          id={item.id}
                          status={item.status}
                          onChange={() => {
                            getCar();
                          }}
                        />
                      </td>
                      <Td textAlign="center">{item.code_car_fleet}</Td>
                      <Td textAlign="center">{item.plaque}</Td>
                      <Td textAlign="center">
                        {item.structure_type.group_type}
                      </Td>
                      <Td textAlign="center">{item.structure_type.type}</Td>
                      <Td textAlign="center">{item.code_etank}</Td>
                      <Td textAlign="center">{item.model}</Td>
                      <Td textAlign="center">
                        {item.year_model}/{item.year_fabrication}
                      </Td>

                      <Td textAlign="center">{item.property}</Td>
                      <Td textAlign="center">{statusCar(item.status)}</Td>
                      <Td textAlign="center" width="10">
                        <Button
                          size="sm"
                          fontSize="sm"
                          as="a"
                          href={`/frota/atualizar/${item.id}`}
                        >
                          <Icon fontSize="16px" as={RiPencilFill} />
                        </Button>
                        <Button
                          size="sm"
                          ml={1}
                          fontSize="sm"
                          onClick={() => {
                            setCarInfo(item);
                            onOpen();
                          }}
                        >
                          <Icon fontSize="16px" as={RiCloseFill} />
                        </Button>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        )}
      </SimpleGrid>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isCentered
        motionPreset="slideInBottom"
        closeOnEsc={false}
        closeOnOverlayClick={false}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Remover Frota
            </AlertDialogHeader>

            <AlertDialogBody>
              {!loadingDelete && (
                <Text>
                  Deseja remover a frota:{" "}
                  <strong>
                    {carInfo?.group_name} {carInfo?.structure_type?.type} Placa:{" "}
                    {carInfo?.plaque}
                  </strong>
                </Text>
              )}

              {loadingDelete && (
                <Flex width="100%" alignItems="center" justifyContent="center">
                  <Spinner
                    color="green.600"
                    emptyColor="white"
                    thickness="4px"
                    size="xl"
                    h={50}
                    w={50}
                  />
                </Flex>
              )}
            </AlertDialogBody>

            <AlertDialogFooter>
              {!loadingDelete && (
                <>
                  <Button
                    colorScheme="red"
                    onClick={() => {
                      deleteCarData(carInfo?.id);
                    }}
                  >
                    Sim
                  </Button>
                  <Button ml={3} onClick={onClose}>
                    Nāo
                  </Button>
                </>
              )}
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
}

function statusCar(status: string) {
  if (status === "active") {
    return <Badge colorScheme="green">Ativa</Badge>;
  }

  if (status === "disabled") {
    return <Badge colorScheme="red">Desativada</Badge>;
  }
}
